export const IllustrationSize = '84px';